import { render, staticRenderFns } from "./PostFacilitiesAlert.vue?vue&type=template&id=e0f5aea2&scoped=true&"
import script from "./PostFacilitiesAlert.vue?vue&type=script&lang=js&"
export * from "./PostFacilitiesAlert.vue?vue&type=script&lang=js&"
import style0 from "./PostFacilitiesAlert.vue?vue&type=style&index=0&id=e0f5aea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f5aea2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
